import { format, formatDistanceToNow } from "date-fns";

// One date helper for v2. Five v1 files format dates inline with toLocaleDateString
// and a sixth keeps a private formatDate, so the same timestamp renders three
// different ways depending on which screen you are looking at.

export const fmtDate = (v) => {
  try { return format(new Date(v), "dd MMM yyyy"); } catch { return "—"; }
};

export const fmtDateTime = (v) => {
  try { return format(new Date(v), "dd MMM yyyy, HH:mm"); } catch { return "—"; }
};

export const fmtRelative = (v) => {
  try { return formatDistanceToNow(new Date(v), { addSuffix: true }); } catch { return "—"; }
};
